import { Button, CircularProgress, Stack, styled } from "@mui/material";

const CustomButton = styled(Button)({
	width: '12rem',
	height: '2.2rem',
	border: '1px solid #D6D8E5',
	textTransform: 'capitalize',
	fontSize: '16px'
});

const CustomButtonWithoutBorder = styled(Button)({
	width: '12rem',
	height: '2.2rem',
	textTransform: 'capitalize',
	fontSize: '16px'
});

const FooterSection = styled(Stack)({
	height: '5rem',
	width: '100%',
	borderTop: '1px solid #E7E7FF',
	paddingTop : "20px"
})

const StickyFooter = (props) => {

	return (
		<FooterSection
			flexDirection="row"
			alignItems="center"
			justifyContent="center"
			gap={2}
		>
			<CustomButton onClick={props.handleCancel} variant="outlined" sx={{ color: '#727484', '&:hover': { border: '1px solid #D6D8E5' } }}>
				Cancel
			</CustomButton>
			<CustomButtonWithoutBorder variant="contained" disabled={props.isSaving || props.isDisabled} onClick={() => props.saveProfile()} sx={{ backgroundColor: '#376afa', '&:hover': { backgroundColor: '#1d56f5' } }}>
				Save Changes
				{props.isSaving && <CircularProgress size={'1rem'} sx={{ ml: 1 }} color="secondary" />}
			</CustomButtonWithoutBorder>
		</FooterSection>
	);
};

export default StickyFooter;
